import {fromJS} from 'immutable';

const individual = ['!=', ['get', 'cluster'], true];
const clustered = ["has", "point_count"];
const wsde = ['==', ['get', 'Category'], 'wsde'];
const sbdc = ['==', ['get', 'Category'], 'sbdc'];
const clt = ['==', ['get', 'Category'], 'clt'];
const fcu = ['==', ['get', 'Category'], 'fcu'];
const mutual = ['==', ['get', 'Category'], 'mutual'];
const tenant = ['==', ['get', 'Category'], 'tenant'];

// export const colors = ['#fb8072','#ffffb3','#8aff87','#bc80bd','#d9d9d9'];
export const colors = ['#FF0000', '#3CEF6F', '#8F39EA', '#FFFF00', '#0059FF', '#FB8072']

export const dataLayers = [
  {
	  "id": "Worker Self-Directed Enterprises",
	  "source": "dpps",
	  "type": "circle",
	  "interactive": true,
	  "filter": [ "all",
	  	individual,
	  	wsde
	  ],
    'paint': {
	    "circle-color": colors[0],
    	"circle-radius": 5
    }
	},
	{
	  "id": "Small Business Development Centers",
	  "source": "dpps",
	  "type": "circle",
	  "interactive": true,
	  "filter": ["all",
	  	individual,
	  	sbdc
	  ],
    'paint': {
	    'circle-color': colors[1],
    	"circle-radius": 5
    }
	},
	{
	  "id": "Community Land Trusts",
	  "source": "dpps",
	  "type": "circle",
	  "interactive": true,
	  "filter": ["all",
	  	individual,
	  	clt
	  ],
    'paint': {
	    'circle-color': colors[2],
    	"circle-radius": 5
    }
	},
  {
    "id": "Federal Credit Unions",
    "source": "dpps",
    "type": "circle",
    "interactive": true,
    "filter": ["all",
      individual,
      fcu
    ],
    'paint': {
      'circle-color': colors[3],
      "circle-radius": 5
    }
  },
  {
    "id": "Mutual Aid Groups",
    "source": "dpps",
    "type": "circle",
    "interactive": true,
    "filter": ["all",
      individual,
      mutual
    ],
    'paint': {
      'circle-color': colors[3],
      "circle-radius": 5
    }
  },
  {
    "id": "Tenant Unions",
    "source": "dpps",
    "type": "circle",
    "interactive": true,
    "filter": ["all",
      individual,
      tenant
    ],
    'paint': {
      'circle-color': colors[5],
      "circle-radius": 5
    }
  }
];

export const defaultClusterLayers = fromJS([
	{
		"id": "Clusters",
		"type": "circle",
		"interactive": true,
		"source": "dpps",
		"filter": clustered,
		"paint": {
			"circle-stroke-width": 3,
			"circle-stroke-color": "#FFF",
			"circle-radius": [
				"step",
				["get", "point_count"],
				20,
				50,
				30,
				75,
				40
			],
			"circle-color": "hsla(0, 0%, 0%, 0)"
		}
	},
	{
		"id": "Cluster-count",
		"type": "symbol",
		"source": "dpps",
		"filter": clustered,
		"layout": {
			"text-field": "{point_count_abbreviated}",
			"text-font": ["Helvetica Bold"],
			"text-size": 14,
      "text-letter-spacing": .15
		},
		"paint": {
			"text-color": "#FFF"
		}
	}
]);

export const blackRaceOverlay = {
	"id": "blackRaceOverlay",
	"source": "blackRaceOverlay",
  "type": "raster",
};

export const allRaceOverlay = {
	"id": "allRaceOverlay",
	"source": "allRaceOverlay",
  "type": "raster",
};

export const overlaySources = {
	"blackRaceOverlay": {
	  "type": "raster",
	  "url": "https://www.justicemap.org/tile/{size}/black/{z}/{x}/{y}.png"
	},
	"allRaceOverlay": {
	  "type": "raster",
	  "url": "https://demographics.virginia.edu/DotMap/tiles4/{z}/{x}/{y}.png"
	}
};

// const CJSource = JSON.stringify({
//   "type": "FeatureCollection",
//   "features": [{
//     "type": "Feature",
//     "geometry": {
//       "type": "Point",
//       "coordinates": [
//         -90.17999999999999,
//         32.3
//       ]
//     }
//   }]
// });

export const defaultMapStyle = fromJS({
  "version": 8,
  "name": "WSDE",
  "metadata": {
    "mapbox:autocomposite": false,
    "mapbox:type": "template",
    "mapbox:groups": {
      "b6371a3f2f5a9932464fa3867530a2e5": {
        "name": "Transportation",
        "collapsed": false
      },
      "a14c9607bc7954ba1df7205bf660433f": {
        "name": "Boundaries"
      },
      "101da9f13b64a08fa4b6ac1168e89e5f": {
        "name": "Places",
        "collapsed": false
      }
    },
    "openmaptiles:version": "3.x",
    "openmaptiles:mapbox:owner": "openmaptiles",
    "openmaptiles:mapbox:source:url": "mapbox://openmaptiles.4qljc88t"
  },
  "sources": {
    "openmaptiles": {
      "type": "vector",
      "url": "https://api.maptiler.com/tiles/v3/tiles.json?key=qPJOrAhyH36Qb6m5TNCZ"
    },
    // "cj": {
    //   "type": "geojson",
    //   "data": CJSource
    // }
  },
  "sprite": "https://openmaptiles.github.io/dark-matter-gl-style/sprite",
  "glyphs": "https://api.maptiler.com/fonts/{fontstack}/{range}.pbf?key=qPJOrAhyH36Qb6m5TNCZ",
  "layers": [
    {
      "id": "background",
      "type": "background",
      "paint": {
        "background-color": "rgba(87, 87, 87, 1)"
      }
    },
    {
      "id": "water",
      "type": "fill",
      "source": "openmaptiles",
      "source-layer": "water",
      "filter": [
        "==",
        "$type",
        "Polygon"
      ],
      "layout": {
        "visibility": "visible"
      },
      "paint": {
        "fill-color": "rgba(0, 0, 0, 1)",
        "fill-antialias": false
      }
    },
    {
      "id": "landcover_ice_shelf",
      "type": "fill",
      "source": "openmaptiles",
      "source-layer": "landcover",
      "maxzoom": 8,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Polygon"
        ],
        [
          "==",
          "subclass",
          "ice_shelf"
        ]
      ],
      "layout": {
        "visibility": "visible"
      },
      "paint": {
        "fill-color": "rgb(12,12,12)",
        "fill-opacity": 0.7
      }
    },
    {
      "id": "landcover_glacier",
      "type": "fill",
      "source": "openmaptiles",
      "source-layer": "landcover",
      "maxzoom": 8,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Polygon"
        ],
        [
          "==",
          "subclass",
          "glacier"
        ]
      ],
      "layout": {
        "visibility": "visible"
      },
      "paint": {
        "fill-color": "hsl(0, 1%, 2%)",
        "fill-opacity": {
          "base": 1,
          "stops": [
            [
              0,
              1
            ],
            [
              8,
              0.5
            ]
          ]
        }
      }
    },
    {
      "id": "landuse_residential",
      "type": "fill",
      "source": "openmaptiles",
      "source-layer": "landuse",
      "maxzoom": 9,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Polygon"
        ],
        [
          "==",
          "class",
          "residential"
        ]
      ],
      "layout": {
        "visibility": "visible"
      },
      "paint": {
        "fill-color": "rgba(86, 86, 86, 1)",
        "fill-opacity": 0.4
      }
    },
    {
		  "id": "landcover_grass",
		  "type": "fill",
		  "source": "openmaptiles",
		  "source-layer": "landcover",
		  "minzoom": 9,
		  "filter": [
		    "==",
		    "class",
		    "grass"
		  ],
		  "paint": {
		    "fill-color": "rgba(95, 106, 76, 1)",
		    "fill-opacity": 0.45
		  },
		},
    {
      "id": "landcover_wood",
      "type": "fill",
      "source": "openmaptiles",
      "source-layer": "landcover",
      "minzoom": 10,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Polygon"
        ],
        [
          "==",
          "class",
          "wood"
        ]
      ],
      "layout": {
        "visibility": "visible"
      },
      "paint": {
        "fill-color": "rgb(32,32,32)",
        "fill-opacity": {
          "base": 0.3,
          "stops": [
            [
              8,
              0
            ],
            [
              10,
              0.8
            ],
            [
              13,
              0.4
            ]
          ]
        },
        "fill-translate": [
          0,
          0
        ],
        "fill-pattern": "wood-pattern"
      }
    },
    {
      "id": "landuse_park",
      "type": "fill",
      "source": "openmaptiles",
      "source-layer": "landuse",
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Polygon"
        ],
        [
          "==",
          "class",
          "park"
        ]
      ],
      "layout": {
        "visibility": "visible"
      },
      "paint": {
        "fill-color": "rgb(32,32,32)"
      }
    },
    {
      "id": "waterway",
      "type": "line",
      "source": "openmaptiles",
      "source-layer": "waterway",
      "filter": [
        "==",
        "$type",
        "LineString"
      ],
      "layout": {
        "visibility": "visible"
      },
      "paint": {
        "line-color": "#232338"
      }
    },
    // {
    //   "id": "water_name",
    //   "type": "symbol",
    //   "source": "openmaptiles",
    //   "source-layer": "water_name",
    //   "filter": [
    //     "==",
    //     "$type",
    //     "LineString"
    //   ],
    //   "layout": {
    //     "text-field": "{name:latin}\n{name:nonlatin}",
    //     "symbol-placement": "line",
    //     "text-rotation-alignment": "map",
    //     "symbol-spacing": 500,
    //     "text-font": [
    //       "Metropolis Medium Italic",
    //       "Noto Sans Italic"
    //     ],
    //     "text-size": 12
    //   },
    //   "paint": {
    //     "text-color": "hsla(0, 0%, 0%, 0.7)",
    //     "text-halo-color": "#000",
    //   }
    // },
    {
      "id": "building",
      "type": "fill",
      "source": "openmaptiles",
      "source-layer": "building",
      "minzoom": 12,
      "filter": [
        "==",
        "$type",
        "Polygon"
      ],
      "paint": {
        "fill-color": "#303030",
        "fill-outline-color": "rgb(27 ,27 ,29)",
        "fill-antialias": true
      }
    },
    {
      "id": "aeroway-taxiway",
      "type": "line",
      "metadata": {
        "mapbox:group": "1444849345966.4436"
      },
      "source": "openmaptiles",
      "source-layer": "aeroway",
      "minzoom": 12,
      "filter": [
        "all",
        [
          "in",
          "class",
          "taxiway"
        ]
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "#181818",
        "line-width": {
          "base": 1.55,
          "stops": [
            [
              13,
              1.8
            ],
            [
              20,
              20
            ]
          ]
        },
        "line-opacity": 1
      }
    },
    {
      "id": "aeroway-runway-casing",
      "type": "line",
      "metadata": {
        "mapbox:group": "1444849345966.4436"
      },
      "source": "openmaptiles",
      "source-layer": "aeroway",
      "minzoom": 11,
      "filter": [
        "all",
        [
          "in",
          "class",
          "runway"
        ]
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "rgba(60,60,60,0.8)",
        "line-width": {
          "base": 1.5,
          "stops": [
            [
              11,
              5
            ],
            [
              17,
              55
            ]
          ]
        },
        "line-opacity": 1
      }
    },
    {
      "id": "aeroway-area",
      "type": "fill",
      "metadata": {
        "mapbox:group": "1444849345966.4436"
      },
      "source": "openmaptiles",
      "source-layer": "aeroway",
      "minzoom": 4,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Polygon"
        ],
        [
          "in",
          "class",
          "runway",
          "taxiway"
        ]
      ],
      "layout": {
        "visibility": "visible"
      },
      "paint": {
        "fill-opacity": 1,
        "fill-color": "#000"
      }
    },
    {
      "id": "aeroway-runway",
      "type": "line",
      "metadata": {
        "mapbox:group": "1444849345966.4436"
      },
      "source": "openmaptiles",
      "source-layer": "aeroway",
      "minzoom": 11,
      "filter": [
        "all",
        [
          "in",
          "class",
          "runway"
        ],
        [
          "==",
          "$type",
          "LineString"
        ]
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "#000",
        "line-width": {
          "base": 1.5,
          "stops": [
            [
              11,
              4
            ],
            [
              17,
              50
            ]
          ]
        },
        "line-opacity": 1
      }
    },
    {
      "id": "road_area_pier",
      "type": "fill",
      "metadata": {},
      "source": "openmaptiles",
      "source-layer": "transportation",
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Polygon"
        ],
        [
          "==",
          "class",
          "pier"
        ]
      ],
      "layout": {
        "visibility": "visible"
      },
      "paint": {
        "fill-color": "rgb(12,12,12)",
        "fill-antialias": true
      }
    },
    {
      "id": "road_pier",
      "type": "line",
      "metadata": {},
      "source": "openmaptiles",
      "source-layer": "transportation",
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "in",
          "class",
          "pier"
        ]
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round"
      },
      "paint": {
        "line-color": "rgb(12,12,12)",
        "line-width": {
          "base": 1.2,
          "stops": [
            [
              15,
              1
            ],
            [
              17,
              4
            ]
          ]
        }
      }
    },
    {
      "id": "highway_path",
      "type": "line",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation",
      "minzoom": 12,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "==",
          "class",
          "path"
        ]
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "rgb(27 ,27 ,29)",
        "line-width": {
          "base": 1.2,
          "stops": [
            [
              13,
              1
            ],
            [
              20,
              10
            ]
          ]
        },
        "line-opacity": 0.9,
        "line-dasharray": [
          1.5,
          1.5
        ]
      }
    },
    {
      "id": "highway_minor",
      "type": "line",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation",
      "minzoom": 8,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "in",
          "class",
          "minor",
          "service",
          "track"
        ]
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "rgba(47, 47, 47, 1)",
        "line-width": 1,
        "line-opacity": 0.9
      }
    },
    {
      "id": "highway_major_casing",
      "type": "line",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation",
      "minzoom": 11,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "in",
          "class",
          "primary",
          "secondary",
          "tertiary",
          "trunk"
        ]
      ],
      "layout": {
        "line-cap": "butt",
        "line-join": "miter",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "rgba(220, 220, 220, 0.8)",
        "line-dasharray": [
          12,
          0
        ],
        "line-width": {
          "base": 1.3,
          "stops": [
            [
              10,
              2
            ],
            [
              20,
              23
            ]
          ]
        }
      }
    },
    {
      "id": "highway_major_inner",
      "type": "line",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation",
      "minzoom": 11,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "in",
          "class",
          "primary",
          "secondary",
          "tertiary",
          "trunk"
        ]
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "hsl(0, 0%, 7%)",
        "line-width": {
          "base": 1.3,
          "stops": [
            [
              10,
              1
            ],
            [
              20,
              20
            ]
          ]
        }
      }
    },
    {
      "id": "highway_major_subtle",
      "type": "line",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation",
      "minzoom": 6,
      "maxzoom": 11,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "in",
          "class",
          "primary",
          "secondary",
          "tertiary",
          "trunk"
        ]
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "#2a2a2a",
        "line-width": {
          "stops": [
            [
              6,
              0
            ],
            [
              8,
              1
            ]
          ]
        }
      }
    },
    {
      "id": "highway_motorway_casing",
      "type": "line",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation",
      "minzoom": 7,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "==",
          "class",
          "motorway"
        ]
      ],
      "layout": {
        "line-cap": "butt",
        "line-join": "miter",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "rgba(150, 150, 150, 0.8)",
        "line-width": {
          "base": 1.4,
          "stops": [
            [
              5.8,
              0
            ],
            [
              6,
              1
            ],
            [
              20,
              40
            ]
          ]
        },
        "line-dasharray": [
          2,
          0
        ],
        "line-opacity": 1
      }
    },
    {
      "id": "highway_motorway_inner",
      "type": "line",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation",
      "minzoom": 6,
      "maxzoom": 24,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "==",
          "class",
          "motorway"
        ]
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": {
          "base": 1,
          "stops": [
            [
              5.8,
              "hsla(0, 0%, 85%, 0.53)"
            ],
            [
              6,
              "#000"
            ]
          ]
        },
        "line-width": {
          "base": 1.4,
          "stops": [
            [
              0,
              0
            ],
            [
              6,
              1.3
            ],
            [
              20,
              30
            ]
          ]
        }
      }
    },
    {
      "id": "highway_motorway_subtle",
      "type": "line",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation",
      "minzoom": 6,
      "maxzoom": 6,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "==",
          "class",
          "motorway"
        ]
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "rgba(31, 31, 31, 1)",
        "line-width": 1
      }
    },
    {
      "id": "railway_transit",
      "type": "line",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation",
      "minzoom": 16,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "all",
          [
            "==",
            "class",
            "transit"
          ],
          [
            "!in",
            "brunnel",
            "tunnel"
          ]
        ]
      ],
      "layout": {
        "visibility": "visible",
        "line-join": "round"
      },
      "paint": {
        "line-color": "rgb(35,35,35)",
        "line-width": 3
      }
    },
    {
      "id": "railway_transit_dashline",
      "type": "line",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation",
      "minzoom": 16,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "all",
          [
            "==",
            "class",
            "transit"
          ],
          [
            "!in",
            "brunnel",
            "tunnel"
          ]
        ]
      ],
      "layout": {
        "visibility": "visible",
        "line-join": "round"
      },
      "paint": {
        "line-color": "rgb(12,12,12)",
        "line-width": 2,
        "line-dasharray": [
          3,
          3
        ]
      }
    },
    {
      "id": "railway_minor",
      "type": "line",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation",
      "minzoom": 16,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "all",
          [
            "==",
            "class",
            "rail"
          ],
          [
            "has",
            "service"
          ]
        ]
      ],
      "layout": {
        "visibility": "visible",
        "line-join": "round"
      },
      "paint": {
        "line-color": "rgb(35,35,35)",
        "line-width": 3
      }
    },
    {
      "id": "railway_minor_dashline",
      "type": "line",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation",
      "minzoom": 16,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "all",
          [
            "==",
            "class",
            "rail"
          ],
          [
            "has",
            "service"
          ]
        ]
      ],
      "layout": {
        "visibility": "visible",
        "line-join": "round"
      },
      "paint": {
        "line-color": "rgb(12,12,12)",
        "line-width": 2,
        "line-dasharray": [
          3,
          3
        ]
      }
    },
    {
      "id": "railway",
      "type": "line",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation",
      "minzoom": 13,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "==",
          "class",
          "rail"
        ],
        [
          "!has",
          "service"
        ]
      ],
      "layout": {
        "visibility": "visible",
        "line-join": "round"
      },
      "paint": {
        "line-width": {
          "base": 1.3,
          "stops": [
            [
              16,
              3
            ],
            [
              20,
              7
            ]
          ]
        },
        "line-color": "rgb(35,35,35)"
      }
    },
    {
      "id": "railway_dashline",
      "type": "line",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation",
      "minzoom": 13,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "==",
          "class",
          "rail"
        ],
        [
          "!has",
          "service"
        ]
      ],
      "layout": {
        "visibility": "visible",
        "line-join": "round"
      },
      "paint": {
        "line-color": "rgb(12,12,12)",
        "line-width": {
          "base": 1.3,
          "stops": [
            [
              16,
              2
            ],
            [
              20,
              6
            ]
          ]
        },
        "line-dasharray": [
          3,
          3
        ]
      }
    },
    {
      "id": "highway_name_other",
      "type": "symbol",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation_name",
      "filter": [
        "all",
        [
          "!=",
          "class",
          "motorway"
        ],
        [
          "==",
          "$type",
          "LineString"
        ]
      ],
      "layout": {
        "text-size": 10,
        "text-letter-spacing": .15,
        "text-max-angle": 30,
        "text-transform": "uppercase",
        "symbol-spacing": 350,
        "text-font": [
          "Helvetica Bold",
          "Noto Sans Regular"
        ],
        "symbol-placement": "line",
        "visibility": "visible",
        "text-rotation-alignment": "map",
        "text-pitch-alignment": "viewport",
        "text-field": "{name:latin} {name:nonlatin}"
      },
      "paint": {
        "text-color": "#a5a5a5",
        "text-translate": [
          0,
          0
        ],
        "text-halo-color": "#000",
        "text-halo-width": 1,
        "text-halo-blur": 0
      }
    },
    {
      "id": "highway_name_motorway",
      "type": "symbol",
      "metadata": {
        "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5"
      },
      "source": "openmaptiles",
      "source-layer": "transportation_name",
      "minzoom": 6,
      "maxzoom": 24,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ],
        [
          "==",
          "class",
          "motorway"
        ]
      ],
      "layout": {
        "text-size": 10,
        "text-letter-spacing": .15,
        "symbol-spacing": 350,
        "text-font": [
          "Helvetica Bold",
          "Noto Sans Regular"
        ],
        "symbol-placement": "line",
        "visibility": "visible",
        "text-rotation-alignment": "viewport",
        "text-pitch-alignment": "viewport",
        "text-field": "{ref}"
      },
      "paint": {
        "text-color": "hsl(0, 0%, 37%)",
        "text-translate": [
          0,
          2
        ]
      }
    },
    {
      "id": "boundary_state",
      "type": "line",
      "metadata": {
        "mapbox:group": "a14c9607bc7954ba1df7205bf660433f"
      },
      "source": "openmaptiles",
      "source-layer": "boundary",
      "filter": [
        "==",
        "admin_level",
        4
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round",
        "visibility": "visible"
      },
      "paint": {
        "line-color": "rgba(31, 31, 31, 1)",
        "line-width": {
          "base": 1.3,
          "stops": [
            [
              3,
              1
            ],
            [
              22,
              15
            ]
          ]
        },
        "line-blur": 0.4,
        "line-dasharray": [
          2,
          2
        ],
        "line-opacity": 1
      }
    },
    {
      "id": "boundary_country",
      "type": "line",
      "metadata": {
        "mapbox:group": "a14c9607bc7954ba1df7205bf660433f"
      },
      "source": "openmaptiles",
      "source-layer": "boundary",
      "filter": [
        "==",
        "admin_level",
        2
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round"
      },
      "paint": {
        "line-color": "rgba(23, 23, 23, 1)",
        "line-width": {
          "base": 1.1,
          "stops": [
            [
              3,
              1
            ],
            [
              22,
              20
            ]
          ]
        },
        "line-blur": {
          "base": 1,
          "stops": [
            [
              0,
              0.4
            ],
            [
              22,
              4
            ]
          ]
        },
        "line-opacity": 1
      }
    },
    {
      "id": "place_other",
      "type": "symbol",
      "metadata": {
        "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f"
      },
      "source": "openmaptiles",
      "source-layer": "place",
      "minzoom": 10,
      "maxzoom": 14,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Point"
        ],
        [
          "in",
          "class",
          "hamlet",
          "isolated_dwelling",
          "neighbourhood"
        ]
      ],
      "layout": {
        "text-size": 10,
        "text-letter-spacing": .15,
        "text-transform": "none",
        "text-font": [
          "Helvetica Bold",
          "Noto Sans Regular"
        ],
        "text-justify": "center",
        "visibility": "visible",
        "text-offset": [
          0.5,
          0
        ],
        "text-anchor": "center",
        "text-field": "{name:latin}\n{name:nonlatin}"
      },
      "paint": {
        "text-color": "#a5a5a5",
        "text-halo-color": "#000",
        "text-halo-width": 1,
        "text-halo-blur": 1
      }
    },
    {
      "id": "place_suburb",
      "type": "symbol",
      "metadata": {
        "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f"
      },
      "source": "openmaptiles",
      "source-layer": "place",
      "minzoom": 10,
      "maxzoom": 15,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Point"
        ],
        [
          "==",
          "class",
          "suburb"
        ]
      ],
      "layout": {
        "text-size": 10,
        "text-letter-spacing": .15,
        "text-transform": "none",
        "text-font": [
          "Helvetica Bold",
          "Noto Sans Regular"
        ],
        "text-justify": "center",
        "visibility": "visible",
        "text-offset": [
          0.5,
          0
        ],
        "text-anchor": "center",
        "text-field": "{name:latin}\n{name:nonlatin}"
      },
      "paint": {
        "text-color": "#a5a5a5",
        "text-halo-color": "#000",
        "text-halo-width": 1,
        "text-halo-blur": 1
      }
    },
    {
      "id": "place_village",
      "type": "symbol",
      "metadata": {
        "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f"
      },
      "source": "openmaptiles",
      "source-layer": "place",
      "minzoom": 9,
      "maxzoom": 14,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Point"
        ],
        [
          "==",
          "class",
          "village"
        ]
      ],
      "layout": {
        "text-size": 10,
        "text-letter-spacing": .15,
        "text-transform": "uppercase",
        "text-font": [
          "Helvetica Bold",
          "Noto Sans Regular"
        ],
        "text-justify": "left",
        "visibility": "visible",
        "text-offset": [
          0.5,
          0.2
        ],
        "icon-size": 0.4,
        "text-anchor": "left",
        "text-field": "{name:latin}\n{name:nonlatin}"
      },
      "paint": {
        "text-color": "#a5a5a5",
        "text-halo-color": "#000",
        "text-halo-width": 1,
        "text-halo-blur": 1,
        "icon-opacity": 0.7
      }
    },
    {
      "id": "place_town",
      "type": "symbol",
      "metadata": {
        "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f"
      },
      "source": "openmaptiles",
      "source-layer": "place",
      "minzoom": 7,
      "maxzoom": 15,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Point"
        ],
        [
          "==",
          "class",
          "town"
        ]
      ],
      "layout": {
        "text-size": 10,
        "text-letter-spacing": .15,
        "icon-image": {
          "base": 1,
          "stops": [
            [
              0,
              "circle-11"
            ],
            [
              9,
              ""
            ]
          ]
        },
        "text-transform": "uppercase",
        "text-font": [
          "Helvetica Bold",
          "Noto Sans Regular"
        ],
        "text-justify": "left",
        "visibility": "visible",
        "text-offset": [
          0.5,
          0.2
        ],
        "icon-size": 0.4,
        "text-anchor": {
          "base": 1,
          "stops": [
            [
              0,
              "left"
            ],
            [
              8,
              "center"
            ]
          ]
        },
        "text-field": "{name:latin}\n{name:nonlatin}"
      },
      "paint": {
        "text-color": "#a5a5a5",
        "text-halo-color": "#000",
        "text-halo-width": 1,
        "text-halo-blur": 1,
        "icon-opacity": 0.7
      }
    },
    {
      "id": "place_city",
      "type": "symbol",
      "metadata": {
        "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f"
      },
      "source": "openmaptiles",
      "source-layer": "place",
      "minzoom": 6,
      "maxzoom": 14,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Point"
        ],
        [
          "==",
          "class",
          "city"
        ],
        [
          ">",
          "rank",
          3
        ]
      ],
      "layout": {
        "text-size": 10,
        "text-letter-spacing": .15,
        "icon-image": {
          "base": 1,
          "stops": [
            [
              0,
              "circle-11"
            ],
            [
              9,
              ""
            ]
          ]
        },
        "text-transform": "uppercase",
        "text-font": [
          "Helvetica Bold",
          "Noto Sans Regular"
        ],
        "text-justify": "left",
        "visibility": "visible",
        "text-offset": [
          0.5,
          0.2
        ],
        "icon-size": 0.4,
        "text-anchor": {
          "base": 1,
          "stops": [
            [
              0,
              "left"
            ],
            [
              8,
              "center"
            ]
          ]
        },
        "text-field": "{name:latin}\n{name:nonlatin}"
      },
      "paint": {
        "text-color": "#a5a5a5",
        "text-halo-color": "#000",
        "text-halo-width": 1,
        "text-halo-blur": 1,
        "icon-opacity": 0.7
      }
    },
    {
      "id": "place_city_large",
      "type": "symbol",
      "metadata": {
        "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f"
      },
      "source": "openmaptiles",
      "source-layer": "place",
      "minzoom": 5,
      "maxzoom": 12,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Point"
        ],
        [
          "<=",
          "rank",
          3
        ],
        [
          "==",
          "class",
          "city"
        ]
      ],
      "layout": {
        "text-size": {
          "base": 1,
          "stops": [
            [
              0,
              10
            ],
            [
              9,
              15
            ]
          ]
        },
        "text-letter-spacing": .15,
        "icon-image": {
          "base": 1,
          "stops": [
            [
              0,
              "circle-11"
            ],
            [
              9,
              ""
            ]
          ]
        },
        "text-transform": "uppercase",
        "text-font": [
          "Helvetica Bold",
          "Noto Sans Regular"
        ],
        "text-justify": "left",
        "visibility": "visible",
        "text-offset": [
          0.5,
          0.2
        ],
        "icon-size": 0.4,
        "text-anchor": {
          "base": 1,
          "stops": [
            [
              0,
              "left"
            ],
            [
              8,
              "center"
            ]
          ]
        },
        "text-field": "{name:latin}\n{name:nonlatin}"
      },
      "paint": {
        "text-color": "#a5a5a5",
        "text-halo-color": "#000",
        "text-halo-width": 1,
        "text-halo-blur": 1,
        "icon-opacity": 0.7
      }
    },
    {
      "id": "place_state",
      "type": "symbol",
      "metadata": {
        "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f"
      },
      "source": "openmaptiles",
      "source-layer": "place",
      "minzoom": 4,
      "maxzoom": 12,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Point"
        ],
        [
          "==",
          "class",
          "state"
        ]
      ],
      "layout": {
        "visibility": "visible",
        "text-field": "{name:latin}\n{name:nonlatin}",
        "text-font": [
          "Helvetica Bold",
          "Noto Sans Regular"
        ],
        "text-transform": "uppercase",
        "text-size": {
          "base": 1,
          "stops": [
            [
              0,
              10
            ],
            [
              9,
              15
            ]
          ]
        },
        "text-letter-spacing": .15,
      },
      "paint": {
        "text-color": "#a5a5a5",
        "text-halo-color": "#000",
        "text-halo-width": 1,
        "text-halo-blur": 1
      }
    },
    {
      "id": "place_country_other",
      "type": "symbol",
      "metadata": {
        "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f"
      },
      "source": "openmaptiles",
      "source-layer": "place",
      "maxzoom": 8,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Point"
        ],
        [
          "==",
          "class",
          "country"
        ],
        [
          "!has",
          "iso_a2"
        ]
      ],
      "layout": {
        "visibility": "visible",
        "text-field": "{name:latin}",
        "text-font": [
          "Helvetica Bold",
          "Noto Sans Italic"
        ],
        "text-transform": "uppercase",
        "text-size": {
          "base": 1,
          "stops": [
            [
              0,
              9
            ],
            [
              1,
              11
            ]
          ]
        },
        "text-letter-spacing": .15
      },
      "paint": {
        "text-halo-width": 1,
        "text-halo-color": "#000",
        "text-color": "#a5a5a5"
      }
    },
    {
      "id": "place_country_minor",
      "type": "symbol",
      "metadata": {
        "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f"
      },
      "source": "openmaptiles",
      "source-layer": "place",
      "maxzoom": 8,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Point"
        ],
        [
          "==",
          "class",
          "country"
        ],
        [
          ">=",
          "rank",
          2
        ],
        [
          "has",
          "iso_a2"
        ]
      ],
      "layout": {
        "visibility": "visible",
        "text-field": "{name:latin}",
        "text-font": [
          "Helvetica Bold",
          "Noto Sans Regular"
        ],
        "text-transform": "uppercase",
        "text-size": {
          "base": 1,
          "stops": [
            [
              0,
              10
            ],
            [
              6,
              12
            ]
          ]
        },
        "text-letter-spacing": .15,
      },
      "paint": {
        "text-halo-width": 1,
        "text-halo-color": "#000",
        "text-color": "#a5a5a5"
      }
    },
    {
      "id": "place_country_major",
      "type": "symbol",
      "metadata": {
        "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f"
      },
      "source": "openmaptiles",
      "source-layer": "place",
      "maxzoom": 6,
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Point"
        ],
        [
          "<=",
          "rank",
          1
        ],
        [
          "==",
          "class",
          "country"
        ],
        [
          "has",
          "iso_a2"
        ]
      ],
      "layout": {
        "visibility": "visible",
        "text-field": "{name:latin}",
        "text-font": [
          "Helvetica Bold",
          "Noto Sans Regular"
        ],
        "text-transform": "uppercase",
        "text-size": {
          "base": 1,
          "stops": [
            [
              0,
              12
            ],
            [
              3,
              14
            ],
            [
              4,
              16
            ]
          ]
        },
        "text-anchor": "center"
      },
      "paint": {
        "text-halo-width": 1,
        "text-halo-color": "#000",
        "text-color": "#a5a5a5"
      }
    },
    // {
    //   "id": "cooperation-jackson",
    //   "type": "symbol",
    //   "source": "cj",
    //   "minzoom": 4,
    //   "layout": {
    //     "visibility": "visible",
    //     "icon-size": {
    //       "base": 1,
    //       "stops": [
    //         [
    //           0,
    //           12
    //         ],
    //         [
    //           3,
    //           14
    //         ],
    //         [
    //           4,
    //           16
    //         ]
    //       ]
    //     },
    //   },
    //   "paint": {
    //     "text-halo-width": 1,
    //     "text-halo-color": "#000",
    //     "text-color": "#a5a5a5"
    //   }
    // }
  ],
  "id": "dual-power"
});


// WEBPACK FOOTER //
// ./src/components/strategy/wsde/mapStyle.js